<template>
  <div class="w-100-h-100">
    <div id="timeLineToolBar">
      <button @click="playCursor" title="Play/Pause">
        <i :class="pause ? 'fas fa-play' : 'fas fa-pause'"></i>
      </button>
      <button @click="resetTimeline" title="Reset">
        <i class="fas fa-stop"></i>
      </button>
      <!-- <button @click="cloneElement">
        <i class="far fa-clone"></i>
      </button> -->
      <button
        @click="removeLine(activeCharacter)"
        title="Delete selected Node(s)"
      >
        <i class="far fa-trash-alt"></i>
      </button>
      <!-- <button @click="uploadJSON" title="Upload JSON">
        <i class="far fa-save"></i>
      </button> -->
      <button
        @click="saveToDBADN(true)"
        title="Save and Upload JSON"
        :class="lastSave != unsaved ? 'unsaved' : 'saved'"
      >
        <i class="fas fa-download"></i>
      </button>
      <button
        @click="playScene"
        
        title="Play scene"
      >
        <i class="fab fa-unity"></i>
      </button>
    </div>
    <div id="timeLineContainer">
      <div id="timeLineSeparationContainer"></div>
      <div id="timeLinePlayCursor" :data-time="currentTimeLineTime"></div>
      <!-- <select name="zoom" id="zommSelection" v-model="zoom" @change="createMms">
        <option value="1" selected="true">x1</option>
        <option value="2">x2</option>
        <option value="10">x10</option>
      </select> -->
      <div class="timeLineFirstLineContainer">
        <div id="ruler"></div>
      </div>
      <div id="timeLineLines" v-if="dropZones.length > 0">
        <div
          class="line"
          v-for="dropZone in dropZones"
          @click="test(dropZone)"
          :key="dropZone.objectId"
        >
          <div
            @click="selectDropZone($event, dropZone)"
            :class="`drop-zone ${dropZone.active ? 'selectedDropZone' : ''} ${hasSubNodes(dropZone)}`"
            :data-active="Boolean(dropZone.active)"
            :id="dropZone.objectId"
            :style="{
              width:
                ((dropZone.endTime - dropZone.startTime) * 20 + 45 > 45
                  ? (dropZone.endTime - dropZone.startTime) * 20 + 45
                  : 45) + 'px',
              left: (dropZone.startTime * 20 || 0) + 'px'
            }"
          >
            <div class="dropDownDropZone">
              <div
                class="featureContainer"
                v-for="feature in dropZoneFeatures(dropZone.objectId)"
                :key="feature.id"
                :id="'element-' + feature.id"
              >
                <div class="featureTitle">
                  <i :class="feature.icon"></i>
                  <!-- <i
                    class="far fa-plus"
                    @click="goToComponent(feature.emit)"
                  ></i> -->
                </div>
                <div class="featureComponentsWrapper">
                  <div
                    v-for="(item, index) in getList(
                      feature.id,
                      dropZone.objectId
                    )"
                    :key="item.id"
                    :id="item.movement ? item.movement.id : item.id"
                    class="feature"
                    :class="`${item.elementType}Feature`"
                     @click="goToComponent(feature, item.movement ? item.movement.id : item.id)"
                     @contextmenu.prevent="showActions(item.id)"
                    :style="
                      featureStyle(
                        getList(feature.id, dropZone.objectId),
                        item,
                        index,
                        dropZone.objectId
                      )

                    "
                  > 
                  <!-- <button class="router" :data-eltype="item.elementType" @click="goToComponent(feature.emit)" ></button> -->
                    <i v-if="item.textToSpeech" :title="item.textToSpeech.text">
                      {{ item.textToSpeech.text }}
                    </i>
                    <i v-if="item.animation" :title="item.animation.name">
                      {{ item.animation.name }}
                    </i>
                    <i
                      v-if="item.movement"
                      :title="item.movement.pathType"
                      :class="feature.icon"
                    >
                    </i>
                    <i
                      v-if="item.sound"
                      :title="item.sound.name"
                      :class="feature.icon"
                    >
                      <small>
                        {{ item.sound.name }}
                      </small>
                    </i>
                    <i
                      v-if="item.effect"
                      :title="item.effect.name"
                      :class="feature.icon"
                    >
                      <small>
                        {{ item.effect.name }}
                      </small>
                    </i>
                    <i
                      v-if="item.light"
                      :title="item.light"
                      :class="feature.icon"
                      class="text-dark"
                    >
                    </i>
                    <button
                      class="removeDropZone"
                      @click="
                        removeFeature(
                          item.movement ? item.movement.id : item.id,
                          item.elementType
                        )
                      "
                      v-if="dropZone.active"
                    >
                      x
                    </button>
                    <!-- <div>
                      <Actions :actions="actions" />
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
            <div
              class="dropZoneImage text-center pt-3"
              @click="goToMain"
              :style="{
                backgroundColor: img(dropZone) ? '' : dropZone.color ? dropZone.color : (dropZone.type.toLowerCase() === 'sound' ? 'rgb(255, 153, 200)' : 'rgb(74, 143, 138)'),
                backgroundImage: 'url(' + img(dropZone) + ')'
              }"
            >
              <i
                v-if="dropZone.type.toLowerCase() === 'sound'"
                class="fa fa-volume-up"
              />
              <i
                v-if="dropZone.type.toLowerCase() === 'video'"
                class="fa fa-video"
              />
              <i
                v-if="dropZone.type.toLowerCase() === 'light'"
                class="fa fa-lightbulb text-dark"
              />
              <i class="dropZoneName">{{ dropZone.name || dropZone.objectName }}</i>
              <button
                class="removeDropZone"
                @click="removeLine(dropZone)"
                v-if="dropZone.active"
              >
                x
              </button>
            </div>
            <button
              v-if="['character','object3d'].indexOf(dropZone.type.toLowerCase()) !== -1"
              class="expandDropZoneButton"
              @click="openCloseDropDown($event)"
            >
              <i class="fas fa-chevron-down"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { uuid } from 'vue-uuid'
import { db } from '../../../firebaseDB'
import Swal from 'sweetalert'
import { mapActions, mapGetters, mapState } from 'vuex'
// import defaultTimeLineImage from '../../../assets/greybot.jpg'
import Actions from '../../global/sections/Actions.vue'

export default {
  data () {
    return {
      // defaultTimeLineImage,
      zoom: 1,
      currentTimeLineTime: '00:00',
      loading: false,
      dropZones: [],
      pause: true,
      features: [
        {
          id: 1,
          icon: 'far fa-comment',
          title: 'TextToSpeech',
          emit: 'Tts'
        },
        {
          id: 2,
          icon: 'fas fa-running',
          title: 'Animation',
          emit: 'Animation'
        },
        { id: 3, icon: "far fa-lightbulb", title: "Light", emit: 'Light'  },
        { id: 4, icon: 'fas fa-volume-up', title: 'Sound', emit: 'Sound'  },
        { id: 5, icon: 'fab fa-react', title: 'Movement', emit: 'Movement' },
        { id: 6, icon: 'fas fa-magic', title: 'Effect', emit: 'Effect' }
      ],
      // nameVal
      items: [],
      animations: [],
      leftPosition: 0,
      width: 345,
      inputData: {},
      presence: 0,
      timeLineLoading: true,
      activeCharacter: {},
      assets: 1,
      path: 0,
      selectedLogic: null,
      lastSave: '',
      unsaved: '',
      canDrag: false,
      actions: [{
                    name : 'update',
                    click : "view",
                    icon : '<i class="far fa-edit"></i>',
                    color : "#1979E7",
                    action : 'update'
                },
                {
                    name : "",
                    click : "view",
                    icon : '<i class="far fa-eye"></i>',
                    color : "#05D33F",
                    action : 'view'
                }]
    }
  },
  components: {
    Actions
  },
  watch: {
    activeCharacter (val) {
      val.objectId && window.unityInstance && window.unityInstance.SendMessage("AssetHandler","SetAssetSelectedWithId",val.objectId.toString());
      this.$root.$emit('changeObjectId', val.objectId)
      var _this = this
      if (val.hasOwnProperty('type')) {
        switch (val.type.toLowerCase()) {
          case 'video':
            _this.$root.$emit('showInspector', val.type.toLowerCase())
            break;
          case 'character':
            _this.$root.$emit('showInspector', val.type.toLowerCase())
            break;
          case 'object3d':
            _this.$root.$emit('showInspector', val.type.toLowerCase())
            break;
          case 'light':
            _this.$root.$emit('showInspector', val.type.toLowerCase())
            break;
          case 'sound':
            _this.$root.$emit('showInspector', val.type.toLowerCase())
            break;
          case 'image':
            _this.$root.$emit('showInspector', val.type.toLowerCase())
            break;
          case 'effect':
            _this.$root.$emit('showInspector', val.type.toLowerCase())
            break;
          default:
            break;
        }
      }
    },
    timeLineLoading (val) {
      let _this = this
      if (val === false) {
        let found = false
        var first
        for (let i = 0; i < this.dropZones.length; i++) {
          const char = this.dropZones[i]
          if (char.active) {
            this.activeCharacter = char
            $('#' + char.objectId).addClass('selectedDropZone')
            found = true
          }
        }
        if (!found) {
          first = $('.drop-zone')
            .first()
            .attr('id')
        }
        this.$store.dispatch(
          'updateCharacters',
          this.dropZones.map(char =>
            char.objectId == first
              ? { ...char, active: true }
              : { ...char, active: false }
          )
        )
        this.dropZones = []
      }
    },
    getTts (val, oldVal) {
      if (val) {
        this.items = this.items = this.items.filter(item => item.data.list != 1)
        for (let i = 0; i < val.length; i++) {
          this.createEl(val[i], 1, 1)
        }
      }
    },
    getAnimations (val, oldVal) {
      if (val) {
        this.items = this.items.filter(item => item.data.list != 2)
        for (let i = 0; i < val.length; i++) {
          val[i].animation.duration =
            (val[i].animation.endTime - val[i].animation.startTime) *
            val[i].animation.loopCount
          this.createEl(val[i], 1, 2)
        }
      }
    },
    zoom () {
      this.handleDragAndResize()
    },
    characters (val) {
      this.activeCharacter = {}
      this.dropZones = []
      let unsavedArray = []
      for (let i = 0; i < val.length; i++) {
        const char = val[i]
        if (char.active) {
          this.activeCharacter = char
        }
      }
      if (this.dropZones.length < 1 && this.dropZones !== this.characters) {
        /**/
        this.addLine()
        this.dropZones = val
      } else {
        this.dropZones = val
      }
      for (var i = val.length - 1; i >= 0; i--) {
        let char = val[i]
        if (char.type === 'object3D') {
          let item = {
            elementType: 'Object3D',
            object3D: {
              ...char,
              object3DElements: char.hasOwnProperty('object3DElements')
                ? char.object3DElements
                : []
            }
          }
          // delete item.object3D.active
          unsavedArray.push(item)
        } else if (char.type === 'Character') {
          let item = {
            elementType: 'Character',
            character: {
              ...char,
              characterElements: char.hasOwnProperty('characterElements')
                ? char.characterElements
                : []
            }
          }
          // delete item.character.active
          unsavedArray.push(item)
        } else if (char.type === 'Sound') {
          let item = {
            elementType: 'Sound',
            sound: {
              ...char
            }
          }
          // delete item.character.active
          unsavedArray.push(item)
        } else if (char.type === 'Object2D') {
          let item = {
            elementType: 'Object2D',
            object2D: {
              ...char
            }
          }
          // delete item.character.active
          unsavedArray.push(item)
        } else if (char.type === 'Effect') {
          let item = {
            elementType: 'Effect',
            effect: {
              ...char
            }
          }
          // delete item.character.active
          unsavedArray.push(item)
        }
      }
      this.unsaved = JSON.stringify(unsavedArray)
        .replaceAll('"active":true', '')
        .replaceAll('"active":false', '')
      this.positionElements();
    }
  },
  computed: {
    ...mapGetters(['getTts', 'getAnimations', 'getVideos']),
    ...mapState(['fbxModels', 'characters', 'propModels', 'effects'])
  },
  methods: {
    positionElements() {
      setTimeout(() => {
        $('.dropDownDropZone').each(function() {
          const margin = $(this).children('.featureContainer').length * 50
          if ($(this)
                .parent()
                .children()
                .first()
                .hasClass('openDropDown'))
            $(this)
              .parent()
              .parent()
              .css('marginBottom', margin) 
        })
      }, 50)
    },
    playScene(){
      this.$root.$emit('playScene')
    },
    goToComponent (emit,id) {
      this.$root.$emit('changeComponent', {
        type: this.activeCharacter.type,
        emit
      })
      setTimeout(() => {
        $('.inspectorElements').removeClass('active');
        $('#'+id+'.inspectorElements').addClass('active');
      }, 200)
    },
    getElementById (id) {
      return this.characters.filter(char => char.objectId == id)[0]
    },
    hasSubNodes(dropZone){
      let subnodesObjectName = dropZone.type+'Elements'
      let subnodesObjectName2 = dropZone.type.toLowerCase()+'Elements'
      let subnodes = dropZone.hasOwnProperty(subnodesObjectName) ? dropZone[subnodesObjectName] : undefined
      if(dropZone.hasOwnProperty(subnodesObjectName)){
        subnodes = dropZone[subnodesObjectName]
      }else if(dropZone.hasOwnProperty(subnodesObjectName2)){
        subnodes = dropZone[subnodesObjectName2]
      }
      if(subnodes){
        const subnodesCount = () =>{
          switch (subnodes.constructor){
            case Object:
              return Object.keys(subnodes).filter(el => el !== 'test').length
            case Array:
              return subnodes.length
            default:
              return 0
          }
        }
        if (subnodesCount() === 0){
          return 'noDropDown'
        }else{
          return ''
        }
      }else{
        return 'noDropDown'
      }
    },
    saveToDBADN (upload=false) {
      let _this = this
      let tRef = db.ref().child('stories/' + localStorage.getItem('storyId'))
      tRef.once('value').then(async snapshot => {
        let json = snapshot.val().json
        var allChars = []
        let nodeDataArray = ((snapshot.val() && snapshot.val().diagram) ? snapshot.val().diagram.nodeDataArray || [] : []).filter(n => n.key !== 'Start');
        let selectedNodePosition = nodeDataArray.findIndex(n => n.key == this.selectedLogic.key)
        allChars = json.mainStory.nodes[selectedNodePosition].nodeElements
        var updatedValues = []
        if (allChars) {
          for (var i = this.characters.length - 1; i >= 0; i--) {
            var found = false
            let char = this.characters[i]
            for (var j = allChars.length - 1; j >= 0; j--) {
              let el = allChars[j]
              if (el.hasOwnProperty('object3D')) {
                if (el.object3D.objectId == char.objectId) {
                  char.object3DElements =
                  char.object3DElements &&
                  char.object3DElements.length ?
                  char.object3DElements.map(el =>
                    el.elementType === 'TextToSpeech'
                        ? delete el.textToSpeech.audioObject &&
                          delete el.textToSpeech.voiceList &&
                          delete el.textToSpeech.voiceEffects &&
                          delete el.textToSpeech.placeHolderText &&
                          delete el.textToSpeech.isAudioPlaying &&
                          delete el.textToSpeech.audioPlayComplete && {
                            ...el,
                            textToSpeech: {
                              ...el.textToSpeech,
                              // language: el.textToSpeech.languageCode.country.split(
                              //   '('
                              // )[0]
                            }
                          }
                        : el.elementType === 'Sound' 
                        ? delete el.sound.audio &&
                          delete el.sound.isAudioPlaying &&
                          delete el.sound.isCopied &&
                          delete el.sound.selectSingle && {
                            ...el,
                            sound: {
                              ...el.sound
                            }
                          }
                        : el.elementType === 'Effect'
                        ? delete el.effect.isCopied &&
                          delete el.effect.selectSingle && {
                            ...el,
                            effect: {
                              ...el.effect
                            }
                          }
                        : el
                    )
                  : []
                  let item = {
                    elementType: 'Object3D',
                    object3D: char
                  }
                  // delete item.object3D.active
                  found = true
                  updatedValues.push(item)
                }
              } else if (el.hasOwnProperty('character')) {
                if (el.character.objectId == char.objectId) {
                  char.characterElements =
                    char.characterElements && char.characterElements.length
                      ? char.characterElements.map(el =>
                          el.elementType === 'TextToSpeech'
                            ? delete el.textToSpeech.audioObject &&
                              delete el.textToSpeech.voiceList &&
                              delete el.textToSpeech.voiceEffects &&
                              delete el.textToSpeech.placeHolderText &&
                              delete el.textToSpeech.isAudioPlaying &&
                              delete el.textToSpeech.audioPlayComplete && {
                                ...el,
                                textToSpeech: {
                                  ...el.textToSpeech,
                                  // language: el.textToSpeech.languageCode.country.split(
                                  //   '('
                                  // )[0]
                                }
                              }
                            : el.elementType === 'Sound' 
                            ? delete el.sound.audio &&
                              delete el.sound.isAudioPlaying &&
                              delete el.sound.isCopied &&
                              delete el.sound.selectSingle && {
                                ...el,
                                sound: {
                                  ...el.sound
                                }
                              }
                            : el.elementType === 'Effect'
                            ? delete el.effect.isCopied &&
                              delete el.effect.selectSingle && {
                                ...el,
                                effect: {
                                  ...el.effect
                                }
                              }
                            : el
                        )
                      : []
                  let item = {
                    elementType: 'Character',
                    character: char
                  }
                  // delete item.character.active
                  found = true
                  updatedValues.push(item)
                }
              } else if(el.hasOwnProperty('object2D')) {
                if (el.object2D.objectId == char.objectId) {
                  let item = {
                    elementType: 'Object2D',
                    object2D: {
                      ...char
                    }
                  }
                  found = true
                  updatedValues.push(item)
                }
              } else if(el.hasOwnProperty('Sound')) {
                if (el.sound.objectId == char.objectId) {
                  let item = {
                    elementType: 'Sound',
                    sound: {
                      ...char
                    }
                  }
                  found = true
                  updatedValues.push(item)
                }
              } else if(el.hasOwnProperty('Effect')) {
                if (el.effect.objectId == char.objectId) {
                  let item = {
                    elementType: 'Effect',
                    effect: {
                      ...char
                    }
                  }
                  found = true
                  updatedValues.push(item)
                }
              } else if(el.hasOwnProperty('light')) {
                if (el.light.objectId == char.objectId) {
                  let item = {
                    elementType: 'Light',
                    light: {
                      ...char
                    }
                  }
                  found = true
                  updatedValues.push(item)
                }
              }
            }
            if (!found) {
              if (char.type === 'object3D') {
                char.object3DElements =
                  char.object3DElements &&
                  char.object3DElements.map(el =>
                    el.elementType === 'TextToSpeech'
                      ? delete el.textToSpeech.audioObject &&
                        delete el.textToSpeech.voiceList &&
                        delete el.textToSpeech.voiceEffects &&
                        delete el.textToSpeech.placeHolderText &&
                        delete el.textToSpeech.isAudioPlaying &&
                        delete el.textToSpeech.audioPlayComplete && {
                          ...el,
                          textToSpeech: {
                            ...el.textToSpeech,
                          }
                        }
                        : el.elementType === 'Sound' 
                            ? delete el.sound.audio &&
                              delete el.sound.isAudioPlaying &&
                              delete el.sound.isCopied &&
                              delete el.sound.selectSingle && {
                                ...el,
                                sound: {
                                  ...el.sound
                                }
                              }
                      
                      : el
                  )
                let item = {
                  elementType: 'Object3D',
                  object3D: char
                }
                // delete item.object3D.active
                updatedValues.push(item)
              } else if (char.type === 'Character') {
                char.characterElements =
                  char.characterElements &&
                  char.characterElements.map(el =>
                    el.elementType === 'TextToSpeech'
                      ? delete el.textToSpeech.audioObject &&
                        delete el.textToSpeech.voiceList &&
                        delete el.textToSpeech.voiceEffects &&
                        delete el.textToSpeech.placeHolderText &&
                        delete el.textToSpeech.isAudioPlaying &&
                        delete el.textToSpeech.audioPlayComplete && {
                          ...el,
                          textToSpeech: {
                            ...el.textToSpeech,
                            // language: el.textToSpeech.languageCode.country.split(
                            //   '('
                            // )[0],
                            // voiceLanguage: el.textToSpeech.languageCode.name.substr(0,2) + el.textToSpeech.languageCode.name.substr(el.textToSpeech.languageCode.country.indexOf(' (') + 1,3)
                          }
                        }
                      : el
                  )
                let item = {
                  elementType: 'Character',
                  character: char
                }
                // delete item.character.active
                updatedValues.push(item)
              }else if(char.type === 'Video' || char.type === 'Image'){
                let item = {
                  elementType: 'Object2D',
                  object2D: {
                    ...char
                  }
                }
                updatedValues.push(item)

              } else if(char.type === 'Sound') {
                let item = {
                  elementType: 'Sound',
                  sound: {
                    ...char
                  }
                }
                updatedValues.push(item)
              } else if(char.type === 'Effect') {
                let item = {
                  elementType: 'Effect',
                  effect: {
                    ...char
                  }
                }
                updatedValues.push(item)
              } else if(char.type === 'Light') {
                let item = {
                  elementType: 'Light',
                  light: {
                    ...char
                  }
                }
                updatedValues.push(item)
              }
            }
          } 
        } else {
          for (var i = this.characters.length - 1; i >= 0; i--) {
            let char = this.characters[i]
            if (char.type === 'object3D') {
              let item = {
                elementType: 'Object3D',
                object3D: char
              }
              // delete item.object3D.active
              updatedValues.push(item)
            } else if (char.type === 'Character') {
              let item = {
                elementType: 'Character',
                character: char
              }
              // delete item.character.active
              updatedValues.push(item)
            } else if (char.type === 'Video' || char.type === 'Image') {
              let item = {
                elementType: 'Object2D',
                object2D: {
                  ...char
                }
              }
              // delete item.character.active
              updatedValues.push(item)
            } else if (char.type === 'Sound') {
              let item = {
                elementType: 'Sound',
                sound: char
              }
              // delete item.character.active
              updatedValues.push(item)
            } else if (char.type === 'Effect') {
              let item = {
                elementType: 'Effect',
                effect: char
              }
              // delete item.character.active
              updatedValues.push(item)
            } else if (char.type === 'Light') {
              let item = {
                elementType: 'Light',
                light: char
              }
              // delete item.character.active
              updatedValues.push(item)
            }
          }
        }
        this.lastSave = JSON.stringify(updatedValues)
          .replaceAll('"active":true', '')
          .replaceAll('"active":false', '')
        let maxEndTime = 0
        this.characters.map(char => (char.endTime > maxEndTime) && (maxEndTime = char.endTime))
        json.mainStory.nodes[selectedNodePosition].endTime = maxEndTime
        updatedValues.reverse()
        json.mainStory.nodes[selectedNodePosition].nodeElements = updatedValues
        let previousNodePositionKey = snapshot.val().diagram.linkDataArray.filter((node) => node.to === nodeDataArray[selectedNodePosition].key)[0].from;
          if (json.mainStory.nodes.filter( (node) => node.name === previousNodePositionKey).length > 0 && previousNodePositionKey.startsWith('Scene')) {
            let previousNodePosition = json.mainStory.nodes.filter((node) => node.name === previousNodePositionKey)[0].nodeId;
            json.mainStory.nodes[parseInt(previousNodePosition)].nextNodeID = selectedNodePosition;
          }
        let updates = {}
        updates[localStorage.getItem('storyId') + '/json'] = json
        db.ref('stories')
          .update(updates)
          .then(snapshot => {
            _this.showSuccessToast('Everything is saved successfully')
            _this.activeCharacter = {}
          })
          .catch(e => {
            _this.showErrorToast('Something occured during the save')
          })
      })
      upload && this.uploadJSON()

     },
    img (dropZone) {
      // console.log(this.characters);
      if (dropZone.type === 'Character') {
        return (
          this.fbxModels &&
          this.fbxModels.hasOwnProperty(dropZone.objectDbHash) &&
          dropZone.objectDbHash &&
          this.fbxModels[dropZone.objectDbHash].image.imageURL
        )
      } else if(dropZone.type === 'object3D') {
        return (
          this.propModels &&
          this.propModels.hasOwnProperty(dropZone.objectDbHash) &&
          dropZone.objectDbHash &&
          this.propModels[dropZone.objectDbHash].image.imageURL
        )
      }else if(dropZone.type === 'Effect') {
        return (
          this.effects &&
          this.effects.hasOwnProperty(dropZone.objectDbHash) &&
          dropZone.objectDbHash &&
          this.effects[dropZone.objectDbHash].image.imageURL
        )
      } else if(dropZone.type === 'Image') {
        return dropZone.objectUrl
      }
    },
    cloneElement () {
      if (this.characters.indexOf(this.activeCharacter) != -1) {
        console.log([
          ...this.characters.splice(this.characters.length + 1, 0, {
            ...this.activeCharacter,
            active: false,
            objectId: Math.floor(Date.now() / 1000)
          })
        ])
        this.showSuccessToast('Element cloned successfully !')
      } else {
        this.showErrorToast('Please select a node to clone !')
      }
    },
    featureStyle (list, item, index, objectId) {
      let parentPosition = $('#' + objectId).position()
        ? $('#' + objectId).position().left
        : 0
      if (item) {
          let element = item[item.elementType.charAt(0).toLowerCase() + item.elementType.slice(1)]
          return {
            width: element.duration
              ? element.duration * 20 + 'px'
              : 0 + 'px',
            left:
              this.elementTransition(list, index, item.elementType.charAt(0).toLowerCase() + item.elementType.slice(1)) * 20 -
              parentPosition +
              'px',
            padding: element.duration ? '0.2em' : '0px',
            border: element.duration ? '1px solid #fff' : 'none',
            backgroundColor: element.color || '',
          }
      }
    },
    removeFromDB () {
      if (Object.keys(this.activeCharacter).length) {
        let _this = this
        let tRef = db.ref().child('stories/' + localStorage.getItem('storyId'))
        let selectedLogic = JSON.parse(localStorage.getItem('selectedLogic'))
        tRef.once('value').then(async snapshot => {
          let json = snapshot.val().json
          let storyData = snapshot.val()
          let nodeDataArray = (storyData && storyData.diagram
            ? storyData.diagram.nodeDataArray || []
            : []
          )
            .filter(n => n.key !== 'Start')
            .filter(n => n.category == 'Scene')
          let selectedNodePosition = nodeDataArray.findIndex(
            n => n.key == selectedLogic.key
          )
          let characterElements = []
          var allChars = json.mainStory.nodes[selectedNodePosition].nodeElements
          var allModels =
            allChars.length &&
            allChars.filter(ch => !ch.hasOwnProperty('character'))
          var allCharacters =
            allChars.length &&
            allChars.filter(ch => !ch.hasOwnProperty('object3D'))
          var removed =
            allCharacters.length &&
            allCharacters.filter(
              ch => ch.character.objectId != _this.activeCharacter.objectId
            )
          json.mainStory.nodes[selectedNodePosition].nodeElements = [
            ...removed,
            ...allModels
          ]
          let updates = {}
          updates[localStorage.getItem('storyId') + '/json'] = json
          db.ref('stories')
            .update(updates)
            .then(snapshot => {
              _this.showSuccessToast('Node deleted successfully')
              _this.activeCharacter = {}
            })
            .catch(e => {
              _this.showErrorToast(
                'The node has encountered a problem while removing'
              )
            })
        })
      } else {
        this.showErrorToast('Please select a character first')
      }
      this.$store.dispatch('updateCharacters', this.dropZones)
    },
    test (test = 0) {
      // console.log(this.getElementById(1640311636))
      // console.log(this.lastSave != this.unsaved)
      // console.log(this.lastSave)
      // console.log(this.unsaved)
      // console.log(this.activeCharacter)
      // console.log(this.characters)
    },
    uploadJSON () {
      let callBacks = {
        successCallback: this.showSuccessToast,
        errorCallback: this.showErrorToast
      }
      this.$root.$emit('sendJson')
      // sendJson
      this.$store.dispatch('uploadJSON', callBacks)
    },
    showSuccessToast (text) {
      this.$toast(text, {
        timeout: 3000,
        type: 'success',
        showCloseButtonOnHover: true
      })
    },
    showErrorToast (text) {
      this.$toast(text, {
        timeout: 3000,
        type: 'error',
        showCloseButtonOnHover: true
      })
    },
    elementTransition (list, item, elementType) {
      let transition = 0
      for (let index = 0; index < item; index++) {
        transition += parseFloat(list[index][elementType].duration)
      }
      if (elementType == 'movement') {
        return parseFloat(list[item].movement.waypoints[0].startTime) - transition
      }
      return list[item][elementType].startTime - transition
    },
    playCursor () {
      this.pause = !this.pause
      this.pause
        ? this.$root.$emit('controlPreview', { state: 'Pause' })
        : this.$root.$emit('controlPreview', { state: 'Play' })
    },
    resetTimeline () {
      this.$root.$emit('controlPreview', { state: 'ReSet' })
      this.$root.$emit('controlPreview', { state: 'SetTime', param: "0" })
      $('#timeLinePlayCursor').css('left', 10 + 'px')
      this.$store.dispatch('updateTimeLineCursor', 0)
      this.currentTimeLineTime = '00:00'
      this.pause = true
    },
    goToMain(){
      this.$root.$emit('changeInspector', 'main')
    },
    selectDropZone: function (event, char) {
      this.activeCharacter = char
      let _this = $(event.target)
      let __this = this
      // if (_this.hasClass('dropZoneImage')) {
        var target = _this.closest('.drop-zone')
        var targetId = target.closest('.line').index()
        let selectedAlready = target.hasClass('selectedDropZone')
        var shouldCancel = false;
        $('.drop-zone')
          .removeClass('selectedDropZone')
          .addClass('staticDropZone')

        // if (!selectedAlready) {
          $('.feature').draggable({
            grid: [this.zoom * 4, this.zoom * 4],
            axis: 'x',
            containment: 'parent', 
            drag: function (e) {
              if (__this.canDragElement(e)) {
                setTimeout(() => {
                  __this.changeFeatureTime(e)
                }, 1000);
              }
            },
            //snapMode: "outer",
            revert: function(e){
              if (__this.canDrag) {
                  return false;
              } else {
                  return true;
                  
              }
            }
          })
          $('.MovementFeature').draggable( "option", "snap", '.MovementFeature, #timeLinePlayCursor' );
          $('.LightFeature').draggable( "option", "snap", '.LightFeature, #timeLinePlayCursor' );
          $('.EffectFeature').draggable( "option", "snap", '.EffectFeature, #timeLinePlayCursor' );
          $('.AnimationFeature').draggable( "option", "snap", '.AnimationFeature, #timeLinePlayCursor' );
          $('.SoundFeature').draggable( "option", "snap", '.SoundFeature, #timeLinePlayCursor' );
          $('.TextToSpeechFeature').draggable( "option", "snap", '.TextToSpeechFeature, #timeLinePlayCursor' );

          $('.LightFeature, .EffectFeature, .AnimationFeature, .SoundFeature')
          .resizable({
            handles: 'e',
            containment: 'parent', 
            grid: [this.zoom * 4, this.zoom * 4],
            resize: function (e) {
              console.log($(this).width())
              __this.changeFeatureEndTime(e, $(this).width())
            },
            delay: 250,
            // distance: 0,
            start: function( event, ui ) {
              let maxWidth = __this.maxWidth(event)
              console.log(maxWidth)
              $(".ui-resizable-resizing").resizable( "option", "maxWidth", maxWidth );
            },
          })
         
          target.addClass('selectedDropZone').removeClass('staticDropZone')
          let newCharacters = this.characters
          newCharacters = newCharacters.map(char => ({
            ...char,
            active: false
          }))
          // if (newCharacters[targetId]) {
            newCharacters[targetId] = { ...newCharacters[targetId], active: true }
          // }
          __this.$store.dispatch('updateCharacters', newCharacters)
        // }else{
        //   target.addClass('selectedDropZone').removeClass('staticDropZone')
        // }
      // }
    },
    maxWidth(e) {
      // return 150
      let nodeElementsName = this.activeCharacter.type.charAt(0).toLowerCase() + this.activeCharacter.type.slice(1) + 'Elements'
      let elements = this.activeCharacter[nodeElementsName]
      let max = 99999999;
      let element = elements.filter((el) => {
        return el.id ==  e.target.id
      })[0]
      const type = element.elementType.charAt(0).toLowerCase() + element.elementType.slice(1);
      elements.forEach(el => {
        if(el.elementType == element.elementType && el.id != e.target.id  && parseFloat(el[type].startTime) >= parseFloat(element[type].endTime)){
          if (el[type].startTime < max){
            max = el[type].startTime 
          }
        }
      })
      max = max - parseFloat(element[type].startTime)
      console.log('max',max *20)
      return max * 20 
    },
    deleteFunction () {
      this.dropZones = this.dropZones.filter(
        dropzone => dropzone.objectId !== $('.selectedDropZone').attr('id')
      )
    },
    removeLine (dropZone=this.activeCharacter) {
      let storyData 
      db.ref("stories").child("/" + localStorage.getItem("storyId"))
                .on('value', (snapshot) => {
                    storyData = snapshot.val();
               }) 
      let nextNodeID = storyData.json.mainStory.nodes.filter( (node) => node.name === this.selectedLogic.key)[0].nextNodeID
      let linked =0
      let conditions 
      if(nextNodeID!==-1){
         conditions = storyData.json.mainStory.nodes.filter( (node) => node.nodeId === nextNodeID)[0].conditions
          if(conditions && conditions.length>0){
            conditions.forEach(function (condition, index) {
              if(condition.touch && condition.touch.objectId==dropZone.objectId){ linked=1 }
            })
          }
      }
      if(conditions && conditions.length>0 && nextNodeID!==-1 && linked!=0){
    Swal({
        title: `This element is linked to a logic , Are you sure you want to delete it ?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        focusConfirm: false,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!'
      }).then((result) => {
        if (result) {
        let updates = {}
        storyData.json.mainStory.nodes[nextNodeID].conditions.forEach(function (condition, index) {
          if(storyData.json.mainStory.nodes[nextNodeID].conditions[index].touch.objectId==dropZone.objectId){
            storyData.json.mainStory.nodes[nextNodeID].conditions[index].touch.objectId=''
          }
            })
        updates[localStorage.getItem('storyId') + '/json'] = storyData.json
        db.ref('stories').update(updates).then(snapshot => {  
           this.deleteConfirmed(dropZone)
        })
        }
      })
      }else{
        this.deleteConfirmed(dropZone)
      }
    },
    deleteConfirmed(dropZone){
      this.createSeparation()
      let dropZoneId = dropZone.objectId
      this.removeFromDB()
      this.dropZones = this.dropZones.filter(
        dropzone => dropzone.objectId !== dropZoneId
      )
      this.$root.$emit('removeFromPreview', dropZoneId)
      this.$store.dispatch('updateCharacters', this.dropZones)
    },
    showActions(index) {
      console.log(index)
    },
     handleDragAndResize () {
      const changeEndTime = (id, val) => {
        let objIndex = this.dropZones.findIndex(obj => obj.objectId == id)
        this.dropZones[objIndex].endTime =
          (20 * this.dropZones[objIndex].startTime + val - 45) / 20
        this.$store.dispatch('updateCharacters', [])
        this.$store.dispatch('updateCharacters', this.dropZones)
      }
      const handlDrag = (id, left, w) => {
        let objIndex = this.dropZones.findIndex(obj => obj.objectId == id)
        let nodeElementsName = this.dropZones[objIndex].type.charAt(0).toLowerCase() + this.dropZones[objIndex].type.slice(1) + 'Elements'
        if (this.dropZones[objIndex].hasOwnProperty(nodeElementsName)) {
          let elements = this.dropZones[objIndex][nodeElementsName]
          this.dropZones[objIndex][nodeElementsName] = elements.map(el => {
            let element = el.elementType.charAt(0).toLowerCase() + el.elementType.slice(1)
            el[element] = element == 'movement'
            ? {
              ...el.movement,
              waypoints: el.movement.waypoints.map(point => {
                return {
                  ...point,
                  startTime:
                      (point.startTime -
                      this.dropZones[objIndex].startTime +
                      left / 20).toFixed(2),
                  endTime:
                      (point.endTime -
                      this.dropZones[objIndex].startTime +
                      left / 20).toFixed(2)
                }
              })
            }
            : {
              ...el[element],
              startTime:
                (el[element].startTime -
                this.dropZones[objIndex].startTime +
                left / 20).toFixed(2),
              endTime:
                (el[element].endTime -
                this.dropZones[objIndex].startTime +
                left / 20).toFixed(2)
            }
            return el;
          })
        }
        this.dropZones[objIndex].startTime = (left / 20).toFixed(2)
        this.dropZones[objIndex].endTime =
         ( (20 * this.dropZones[objIndex].startTime + w - 45) / 20).toFixed(2)
        this.$store.dispatch('updateCharacters', []) // for some reason this is the only way to update the main inspector state.character, don't hesitate if you find a better way
        this.$store.dispatch('updateCharacters', this.dropZones)
      }
      $('.drop-zone')
        .draggable({
          grid: [this.zoom * 5, this.zoom * 5],
          containment: 'parent',
          axis: 'x',
          cancel: '.staticDropZone',
          drag: function () {
            handlDrag(
              $(this).attr('id'),
              $(this).position().left,
              $(this).width()
            )
            changeEndTime($(this).attr('id'), $(this).width())
          },
          snap: '#timeLinePlayCursor'
        })
        .resizable({
          handles: 'e',
          cancel: '.staticDropZone',
          grid: [this.zoom * 5, this.zoom * 5],
          resize: function () {
            changeEndTime($(this).attr('id'), $(this).width())
          }
        })
    },
    goToTime(item){
      $('#timeLinePlayCursor').css({left:$(item.target).position().left})
      this.$root.$emit('controlPreview', { state: 'SetTime', param: $(item.target).attr('data-number') })
      this.$store.dispatch('updateTimeLineCursor', parseFloat($(item.target).attr('data-number')))
    },
    openCloseDropDown (event) {
      var target = $(event.target)
      if (target.is('button')) {
        target.toggleClass('openDropDown')
        target
          .parent()
          .children()
          .first()
          .toggleClass('openDropDown')
        const margin =
          $('.dropDownDropZone')
            .first()
            .children('.featureContainer').length * 50
        if (
          target
            .parent()
            .children()
            .first()
            .hasClass('openDropDown')
        ) {
          target
            .parent()
            .parent()
            .css('marginBottom', margin)
        } else {
          target
            .parent()
            .parent()
            .css('marginBottom', 3)
        }
      } else {
        target.parent().click()
      }
    },
    onResize () {
      this.createMms()
    },
    addLine: function () {
      this.dropZones = this.characters
      setTimeout(() => {
        this.handleDragAndResize()
        // this.loading = false
        this.timeLineLoading = false
        this.createSeparation()
      }, 300)
    },
    rulerEnumeration () {
      let rulerCounter = 0
      $('#ruler')
        .children('.mms')
        .each(function () {
          if (rulerCounter % 5 === 0) {
            $(this).attr('data-number', rulerCounter / 5)
            $(this).addClass('moduled')
          }
          rulerCounter += 1
        })
    },
    createSeparation(){
      $('#timeLineSeparationContainer').empty()
      let containerHeight = Math.round(($('#timeLineContainer').height() / 50) + 1)
      let countOfLines = $('#timeLineLines').children().length
      let number_of_separations = containerHeight > countOfLines ? containerHeight : countOfLines
      if ($('#timeLineSeparationContainer .separationLines').length < number_of_separations) {
        for (let i = 0; i < number_of_separations; i++) {
          $('#timeLineSeparationContainer').append(`<div class='separationLines'></div>`)
        }
      }
      // Updating the height of the cursor
      $('#timeLinePlayCursor').height($('#timeLineSeparationContainer').height())
    },
    createMms () {
      $('#ruler').empty()
      let _this = this;
      let number_of_mms = Math.round($('#timeLineContainer').width() / 2) + 48; 
      if ($('#ruler .mms').length < number_of_mms) {
        for (let i = 0; i < number_of_mms; i++) {
          $('#ruler').append(`<div class='mms zx${this.zoom}'></div>`)
        }
      }
      this.rulerEnumeration()
      this.createSeparation()
      $('.moduled').click(function(event){
        _this.goToTime(event)
      })
    },
    createEl (feature, dropZoneId, list) {
      this.items.push({
        dropZoneId,
        data: {
          ...feature,
          list: list
        }
      })
      let _this = this
      setTimeout(() => {
        $('#' + feature.id).css(
          'width',
          feature.textToSpeech
            ? feature.textToSpeech.duration * 20
            : feature.animation
            ? feature.animation.duration * 20
            : 0
        )
      }, 1000)
    },
    canDragElement (e) {
      
      this.canDrag = false
      let nodeElementsName = this.activeCharacter.type.charAt(0).toLowerCase() + this.activeCharacter.type.slice(1) + 'Elements'
      let elements = this.activeCharacter[nodeElementsName]
      let element = elements.filter((el) => {
        return el.id ==  e.target.id || (el.movement && el.movement.id == e.target.id)
      })[0]
      let startTime = (
                  parseFloat(e.target.offsetLeft / 20) +
                  parseFloat(this.activeCharacter.startTime)
                )
      let endTime = (
                  parseFloat((e.target.offsetLeft + e.target.offsetWidth) / 20) +
                  parseFloat(this.activeCharacter.startTime)
                )
      elements = elements.filter((el) => {
        const type = element.elementType.charAt(0).toLowerCase() + element.elementType.slice(1);
        
        return el.elementType == element.elementType 
        && (
          (el.id != e.target.id 
          && (
            (parseFloat(el[type].startTime) == startTime && parseFloat(el[type].endTime) == endTime) 
              || (parseFloat(el[type].startTime) <= parseFloat(startTime) && parseFloat(el[type].endTime) > parseFloat(startTime))
              || (parseFloat(el[type].endTime) >= parseFloat(endTime) && parseFloat(el[type].startTime) < parseFloat(endTime))
              || (parseFloat(el[type].endTime) <= parseFloat(endTime) && parseFloat(el[type].startTime) > parseFloat(endTime))
              || (parseFloat(el[type].startTime) >= parseFloat(startTime) && parseFloat(el[type].endTime) < parseFloat(startTime))
            )
          ) 
          || ((el.movement && el.movement.id != e.target.id) 
            && ( (parseFloat(el[type].waypoints[0].startTime) == startTime && parseFloat(el[type].waypoints[el[type].waypoints.length - 1].endTime) == endTime)
              || (parseFloat(el[type].waypoints[0].startTime) <= parseFloat(startTime) && parseFloat(el[type].waypoints[el[type].waypoints.length - 1].endTime) > parseFloat(startTime))
              || (parseFloat(el[type].waypoints[el[type].waypoints.length - 1].endTime) >= parseFloat(endTime) && parseFloat(el[type].waypoints[0].startTime) < parseFloat(endTime))
              || (parseFloat(el[type].waypoints[0].startTime) >= parseFloat(startTime) && parseFloat(el[type].waypoints[el[type].waypoints.length - 1].endTime) < parseFloat(startTime))
              || (parseFloat(el[type].waypoints[el[type].waypoints.length - 1].endTime) <= parseFloat(endTime) && parseFloat(el[type].waypoints[0].startTime) > parseFloat(endTime))) 
            ) 
          )
      })
      let draggable = !elements.length
      this.canDrag = draggable
      return draggable
    },
    changeFeatureTime (e) {
      let nodeElementsName = this.activeCharacter.type.charAt(0).toLowerCase() + this.activeCharacter.type.slice(1) + 'Elements'
      let elements = this.activeCharacter[nodeElementsName]
      this.activeCharacter = {
        ...this.activeCharacter,
        [nodeElementsName]: elements.map(el => {
          if ((el.movement && el.movement.id == e.target.id)) {
            this.path = 0
            return {
              ...el,
                movement: {
                  ...el.movement,
                  waypoints: el.movement.waypoints.map((point, index) => {
                    if (!index) {
                      this.path =
                          e.target.offsetLeft / 20 +
                          parseFloat(this.activeCharacter.startTime) -
                          parseFloat(point.startTime)
                      return {
                        ...point,
                        startTime: (
                            parseFloat(e.target.offsetLeft / 20) +
                            parseFloat(this.activeCharacter.startTime)
                          ).toFixed(2),
                        endTime: (
                            parseFloat(e.target.offsetLeft / 20) +
                            parseFloat(this.activeCharacter.startTime) +
                            parseFloat(point.duration)
                          ).toFixed(2)
                      }
                    }
                    return {
                      ...point,
                      startTime: (
                          parseFloat(point.startTime) + parseFloat(this.path)
                        ).toFixed(2),
                      endTime: (
                          parseFloat(point.endTime) + parseFloat(this.path)
                        ).toFixed(2)
                    }
                  })
                }
            }
          } else if (el.id === e.target.id) {
            let element = el.elementType.charAt(0).toLowerCase() + el.elementType.slice(1)
            el[element] = {
                ...el[element],
                startTime:
                    (e.target.offsetLeft / 20 + parseFloat(this.activeCharacter.startTime)).toFixed(2),
                endTime: element == 'animation' 
                  ? (e.target.offsetLeft / 20 +
                    parseFloat(this.activeCharacter.startTime) +
                    parseFloat(el.animation.duration) / el.animation.loopCount).toFixed(2)
                  : (e.target.offsetLeft / 20 + parseFloat(this.activeCharacter.startTime) + parseFloat(el[element].duration)).toFixed(2)
            }
          } 
          return el;
        })
      }
      this.reflext()
    },
    changeFeatureEndTime (e, width) {
      let nodeElementsName = this.activeCharacter.type.charAt(0).toLowerCase() + this.activeCharacter.type.slice(1) + 'Elements'
      let elements = this.activeCharacter[nodeElementsName]
      this.activeCharacter = {
        ...this.activeCharacter,
        [nodeElementsName]: elements.map(el => {
          if (el.id === e.target.id) {
            let element = el.elementType.charAt(0).toLowerCase() + el.elementType.slice(1)
            console.log((20 * el[element].startTime + width) / 20)
            el[element] = {
                ...el[element],
                endTime: element != 'animation' 
                  ? ((20 * el[element].startTime + width) / 20).toFixed(2)
                  : ((20 * el[element].startTime + width) / (20 * el[element].loopCount)).toFixed(2),
                duration: width / 20

            }
          } 
          return el;
        })
      }
      this.reflext()
    },
    getList (list, dropZoneId) {
      var _this = this.dropZones.filter(item => item.objectId == dropZoneId)[0]
      var feature = this.features.filter(feature => feature.id === list)[0]
      let elements = _this[_this.type.charAt(0).toLowerCase() + _this.type.slice(1) + 'Elements']
      return (
        elements &&
        elements.filter(
          item => item.elementType === feature.title
        )
      )
    },
    dropZoneFeatures (dropZoneId) {
      return this.features.filter(el => this.getList(el.id, dropZoneId) ? this.getList(el.id, dropZoneId).length : [])
    },
    reflext () {
      // console.log(
      let newChar =
        this.characters &&
        this.characters.map(char =>
          char.objectId === this.activeCharacter.objectId
            ? this.activeCharacter
            : { ...char }
        )
      this.$store.dispatch('updateCharacters', newChar)
    },
    removeFeature (id,elementType) {
      let nodeElementsName = this.activeCharacter.type.charAt(0).toLowerCase() + this.activeCharacter.type.slice(1) + 'Elements'
      if (this.activeCharacter.hasOwnProperty(nodeElementsName)) {
        let elements = this.activeCharacter[nodeElementsName]
        this.activeCharacter[nodeElementsName] = elements.filter(
          el => (el.id && el.id != id) || (el.movement && el.movement.id != id)
        )
        this.reflext()
      }
     this.$root.$emit('removeSubnode', id, elementType, this.activeCharacter.objectId)
    }
  },
  mounted () {
    if (!this.$store.state.stories.length) {
      this.$store.dispatch('listUserStories')
    }
    this.selectedLogic = JSON.parse(localStorage.getItem('selectedLogic'))
    // document.getElementById('timeline-div').addEventListener('resize', this.onResize)
    this.createMms()
    $('#timeLineContainer').click(function(event){
      if(!$(event.target).parents('.drop-zone').length == 1){
        $('.selectedDropZone').removeClass('selectedDropZone')
      }
      event.stopPropagation();
    });
    this.$store.dispatch('updateTimeLineCursor', 0)
    this.$root.$on('deleteSelectedNode', this.removeLine)
    this.$root.$on('saveToDBADN', this.saveToDBADN)
    this.$root.$on('uploadJSON', this.uploadJSON)
    this.$root.$on('expandPanel', () => {
      setTimeout(()=>{
        this.createMms()
      },20)
    })
    this.rulerEnumeration()
    // this.addLine()
    $('*').disableSelection()
    let _this = this
    $('#timeLinePlayCursor').draggable({
      grid: [this.zoom * 4, this.zoom * 4],
      axis: 'x',
      containment: 'parent',
      drag: function () {
        _this.$store.dispatch('updateTimeLineCursor', ($(this).position().left - 10) / 20)
      },
      stop: function( event, ui ) {
        console.log('Emit control preview')
          _this.$root.$emit('controlPreview', { state: 'SetTime',param: (($(this).position().left - 10) / 20).toString()  })
      }
    })
    let max = 0
    window.setInterval(() => {
      if (!this.pause) {
        let left = parseFloat(
          $('#timeLinePlayCursor')
            .css('left')
            .replace('px', '')
        )
        this.currentTimeLineTime = `${
          ((left - 6) / 20).toString().split('.')[0]
        }:${
          ((left - 6) / 20).toString().split('.')[1]
            ? ((left - 6) / 20).toString().split('.')[1] + '0'
            : '00'
        }`
        $('#timeLinePlayCursor').css('left', left + 4 + 'px')
        $('.drop-zone').each(function () {
          let widtLeft =
            $(this).width() +
            parseFloat(
              $(this)
                .css('left')
                .replace('px', '')
            )
          if (widtLeft > max) {
            max = widtLeft
          }
        })
        if (left >= max - 40) {
          this.pause = !this.pause
          this.$root.$emit('controlPreview', { state: 'Pause' })
        }
      }
    }, 200)
  },
  beforeDestroy () {
    this.$root.$off('controlPreview')
    this.$root.$off('deleteSelectedNode')
    this.$root.$off('saveToDBADN')
    this.$root.$off('playScene')
    this.$root.$off('uploadJSON')
    window.removeEventListener('resize', this.onResize)
  }
}
</script>
<style lang="scss" >
    #ruler {
    div {
      border-color: #5f5f60 !important;
      &:before {
        color: #afafaf !important;
      }
    }
  }
</style>
<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.c0mment {
  display: none !important;
}

#inspectorPopup {
  display: none;
}

.w-100-h-100 {
  width: 100%;
  height: 100%;
  display: flex;
}

.drag-el {
  background-color: #3498db;
  color: white;
  padding: 5px;
  margin: 10px;
  max-width: calc(100% / 4);
}

#timeLineToolBar {
  width: 45px;
  height: 100%;
  background-color: #2a2b2b;
  padding: 2px;
  display: flex;
  flex-direction: column;

  button {
    background-color: #333;
    margin-bottom: 2px;
    height: 48px;
    i.far.fa-trash-alt {
      color: rgb(255, 255, 255);
    }
    i.fas.fa-download {
      color: #ffffff;
    }
    &.unsaved {
      box-shadow: 0 0px 10px #47b784;
    }

    &:hover {
      filter: brightness(1.1);

      &:active {
        filter: brightness(0.8);
      }
    }
  }
}

i {
  transition: 0.4s;
}

#timeLineContainer {
  overflow: auto !important;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden auto;
  background-color: #161e31;
  padding: 0 10px;
  position: relative;
    #timeLineSeparationContainer{
      display: flex;
      flex-direction: column;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      z-index: 0;
        .separationLines{
          border-bottom: 1px solid #cccccc32;
          height: 50px;
          width: 100%;
        }    
    }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background: #b3bdde;
    border-radius: 5px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #318d64;
  }

  &::-webkit-scrollbar {
    height: 8px;
    width: 8px;
    border-radius: 5px;
  }

  select {
    option {
      color: #333;
    }
  }

  #timeLinePlayCursor {
    position: absolute;
    width: 1px;
    background-color: red;
    height: 100%;
    z-index: 2;
    /* transition:left .2s; */
    &:before {
      content: '';
      border-top: 10px solid red;
      border-bottom: 10px solid transparent;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      position: absolute;
      top: 0;
      left: -10px;
    }
    &:after {
      content: attr(data-time);
      position: absolute;
      bottom: 0;
      left: 0;
      padding-left: 1em;
      display: none;
    }
  }

  .timeLineFirstLineContainer {
    display: flex;
    width: 100%;
    min-height: 50px;
    /*margin-bottom: 10px;*/

    button.addTimeLineLineButton {
      min-width: 35px;
      background-color: #1555d6;
      color: #fff;
      font-size: 2em;
      border: none;
      cursor: pointer;
      border: 1px solid #1555d6;

      &:hover {
        filter: brightness(1.1);

        &:active {
          filter: brightness(0.8);
        }
      }
    }

    #ruler {
      width: 100%;
      height: 100%;
      display: flex;
      flex-wrap: nowrap;

      .mms {
        width: 4px;
        min-width: 4px;
        background-color: transparent;
        height: 15px;
        border-left: 1px solid #ffffff50;
        position: relative;

        &.zx2 {
          min-width: 10px;
        }

        &.zx10 {
          min-width: 100px;
        }

        &.moduled {
          height: 25px;
          &:hover,&.currentlyOn{
            &::before{
              border-color: #47b784;
              cursor: pointer;
            }
          }

          &::before {
            display: block;
            border: 1px solid transparent;
            border-radius: 50%;
            padding: 2px;
            min-width: 21px;
            text-align: center;
            color: #ffffff50;
            transition: .4s;
          }
        }

        &::before {
          content: attr(data-number);
          top: 111%;
          transform: translateX(-50%);
          position: absolute;
          color: #fff;
          font-size: 10px;
          display: none;
        }
      }
    }
  }

  #timeLineLines {
    z-index: 1;
    display: grid;
    grid-gap: 3px;

    .line {
        height: 44px;
        position: relative;
        transition: 0.4s;
        margin-top: 3px;

      .drop-zone {
        position: relative;
        height: 100%;
        width: 50%;
        cursor: pointer;
        min-height: 10px;
        display: flex;
        flex-wrap: nowrap;
        &[data-active='true'] {
          box-shadow: 0 0 0 1px #7f7f7f;
          button.expandDropZoneButton,
          .dropZoneImage button.removeDropZone {
            opacity: 1;
          }
        }
        &.selectedDropZone {
          box-shadow: 0 0 0 3px #d20000;
          cursor: grab;
        }
        &.staticDropZone {
          .ui-resizable-handle.ui-resizable-e {
            display: none;
          }
        }
        &.noDropDown{
          .expandDropZoneButton{
            opacity: 0;
            visibility: hidden;
          }
          &:after {
            /*right: 0;*/
          }
        }
        &:after {
          content: '';
          width: 1px;
          height: 100vh;
          background-color: red;
          position: absolute;
          bottom: 0;
          right: 44px;
          opacity: 0;
          transition: 0.4s;
        }

        &:hover {
          &:after {
            opacity: 1;
          }

          button.expandDropZoneButton,
          .dropZoneImage button.removeDropZone {
            opacity: 1;
          }
        }

        .dropZoneImage {
          width: 100%;
          height: 100%;
          background-repeat: repeat-x;
          background-size: auto 100%;
          position: relative;
          background-color: #62204d;

          .dropZoneName {
            position: absolute;
            bottom: 0;
            left: 0;
            z-index: 2;
            background-color: #00000082;
            color: #fff;
          }

          button.removeDropZone {
            background-color: #dc3545;
            border: none;
            color: #fff;
            position: absolute;
            right: 0;
            top: 0;
            width: 20px;
            display: flex;
            justify-content: center;
            align-items: center;
            opacity: 0;
            transition: 0.4s;
          }
        }

        .dropDownDropZone {
          position: absolute;
          top: calc(100% + 2px);
          width: 100%;
          /* background-color: ; */
          height: 0px;
          overflow: hidden;

          &.openDropDown {
            height: calc(50px * 6);
          }

          .featureContainer {
            display: flex;
            height: 50px;
            color: #fff;
            border-bottom: 1px solid #333;
            flex-direction: row-reverse;

            .featureTitle {
              min-width: 35px;
              display: flex;
              justify-content: center;
              align-items: center;
              position: relative;
              padding: 0.5em;
              background-color: #444444;
              flex-wrap: nowrap;
              white-space: nowrap;
              font-size: 14px;

              i.fa-plus {
                position: absolute;
                width: 100%;
                height: 100%;
                background-color: #444444;
                top: 0;
                left: 0;
                opacity: 0;
                cursor: pointer;
                display: flex;
                justify-content: center;
                align-items: center;
                transition: 0.4s;
              }

              &:hover {
                i.fa-plus {
                  opacity: 1;
                }
              }
            }

            .featureButtonWrapper {
              button {
                width: 70px;
                height: 100%;
                border-radius: 0;
                border: none;
                cursor: pointer;

                &:hover {
                  filter: brightness(1.1);

                  &:active {
                    filter: brightness(0.8);
                  }
                }
              }
            }

            .featureComponentsWrapper {
              display: flex;
              /* overflow: auto hidden; */
              /* border: 1px solid red; */
              width: 100%;
              position: relative;
              overflow: hidden;

              &::-webkit-scrollbar-track {
                background: #f1f1f1;
              }

              &::-webkit-scrollbar-thumb {
                background: #47b784;
              }

              &::-webkit-scrollbar-thumb:hover {
                background: #318d64;
              }

              &::-webkit-scrollbar {
                height: 8px;
                width: 8px;
              }

              .feature {
                background-color: #67a8f1;
                padding: 0.2em;
                display: flex;
                justify-content: center;
                align-items: center;
                position: relative;
                border: 1px solid #fff;
                max-width: 100%;
                button.router{
                  width: 70%  ;
                  position: absolute;
                  z-index: 2;
                  height: 100%;
                  background: transparent;
                  left: 0;
                }
                button.removeDropZone {
                  background-color: #dc3545;
                  border: none;
                  color: #fff;
                  position: absolute;
                  right: 0;
                  top: 0;
                  width: 20px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  opacity: 0;
                  transition: 0.4s;
                  z-index: 3;
                }

                &:hover {
                  button.removeDropZone {
                    opacity: 1;
                  }
                }

                i {
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
              }
              .AnimationFeature {
                background-color: #c567f1 !important;
              }
              .MovementFeature {
                background-color: #85bea5 !important;
              }
              .SoundFeature {
                background-color: #b5d4f7;
              }
              .EffectFeature {
                background-color: #f1c055;
              }
              // .LightFeature {
              //   background-color: #f1ebde;
              // }
            }
          }
        }

        &.loading {
          filter: blur(2px);
          cursor: not-allowed;

          &:before {
            content: '';
            background-color: #000000;
            z-index: 9;
            top: 0;
            left: 0;
            position: absolute;
            width: 100%;
            height: 100%;
            opacity: 0.8;
            backdrop-filter: blur(8px);
          }
        }

        &.ui-draggable-dragging {
          cursor: grabbing;
        }

        button.expandDropZoneButton {
          position: relative;
          /* min-width: calc(35px + 10px); */
          min-width: 35px;
          height: 100%;
          cursor: pointer;
          border: 1px solid #cccccc80;
          background-color: #333;
          color: #fff;
          font-size: 19px;
          opacity: 0;
          transition: 0.4s;
          margin-left: 10px;

          &.openDropDown {
            opacity: 1;

            i {
              transform: rotateZ(180deg);
            }
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/v2/story-edit-view/newTimeLine.vue